import "../style.css";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { sortByMyPageQuotations } from "../../../../../../utils/dataLists";
import { SearchIcon } from "../../../../../../components/icons";

const QuotationListFilter = ({
    onChangeFilter,
    filterGetQuotations,
    sortByMyPageBookings
}) => {
    const { t } = useTranslation();

    return (
        <div className="tw:hidden tw:md:block">
            <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:justify-between">
                <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none">
                    {/* Customers cannot create quotations (admin-only feature), so the
                        "Create a Quotation" button that used to sit here was removed. The
                        empty column keeps the sort / search controls on the right. */}
                </div>
                <div className="tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none">
                    <div className="tw:flex tw:items-center tw:justify-end tw:gap-4">
                        <div className="tw:flex tw:items-center tw:justify-center tw:gap-2">
                            <p className="tw:m-0 tw:text-[#6c757d]!">{t("myPage.quotation.filter.sortBy")}</p>
                            <select
                                className="tw:block tw:w-full tw:appearance-none tw:[font-family:var(--font-sans-primary)] tw:text-[15px] tw:text-[#4e4e4e] tw:bg-white tw:rounded-[0.3rem] tw:border tw:border-[#E8E8E8] tw:pt-2 tw:pb-[0.375rem] tw:pl-3 tw:pr-9 tw:leading-normal tw:bg-[url(data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20viewBox=%270%200%2016%2016%27%3e%3cpath%20fill=%27none%27%20stroke=%27%23343a40%27%20stroke-linecap=%27round%27%20stroke-linejoin=%27round%27%20stroke-width=%272%27%20d=%27M2%205l6%206%206-6%27/%3e%3c/svg%3e)] tw:bg-no-repeat tw:bg-[right_0.75rem_center] tw:bg-[length:16px_12px] tw:focus:border-black tw:focus:outline-none"
                                name="sortBy"
                                onChange={(e) => onChangeFilter(e)}
                            >
                                {
                                    sortByMyPageQuotations.map((v) => (
                                        <option value={v.value} selected={filterGetQuotations?.orderBy === v.value.split(",")[0] && filterGetQuotations?.sortBy === v.value.split(",")[1]}>{v.label}</option>
                                    ))
                                }
                            </select>
                        </div>
                        <div className="tw:flex tw:items-center tw:justify-center tw:relative">
                            <div className={`tw:rounded-[0.375rem] tw:border tw:border-[#dee2e6]`}>
                                <div className={`tw:flex tw:items-center input-container tw:gap-2`}>
                                    <SearchIcon className="tw:ml-4" />
                                    <input
                                        className={`input-field-search tw:w-full tw:rounded-[0.375rem] tw:border-0 tw:py-2 no-calendar tw:pr-4 tw:pl-0`}
                                        type={"text"}
                                        id={"search"}
                                        placeholder={t("myPage.quotation.filter.search")}
                                        name={"search"}
                                        value={filterGetQuotations.search}
                                        onChange={(e) => onChangeFilter(e)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuotationListFilter;
